import { useCallback, useMemo } from "react";

import { useBlock } from "@/components/PowerBlock/Block/block-store";
import { MCPConfiguration } from "@/types/evaluate";

const useFunctionSelection = (
  blockStore: ReturnType<typeof useBlock<MCPConfiguration>>,

  inputData: { path: string; source: string }[],
) => {
  const handleInputDataChange = useCallback(
    (key: string, source: string | undefined) => {
      let newInputData = [...inputData];

      if (source === undefined) {
        // Remove the mapping
        newInputData = newInputData.filter(item => item.path !== key);
      } else {
        // Update or add the mapping
        const existingIndex = newInputData.findIndex(item => item.path === key);
        if (existingIndex >= 0) {
          newInputData[existingIndex] = { path: key, source };
        } else {
          newInputData.push({ path: key, source });
        }
      }

      blockStore.setConfiguration({
        ...blockStore.configuration,
        input_data: newInputData,
      } as MCPConfiguration);
    },
    [blockStore, inputData],
  );

  // Create input data mapping from configuration
  const inputDataMapping = useMemo(() => {
    const mapping: Record<string, string> = {};
    inputData.forEach(item => {
      mapping[item.path] = item.source;
    });
    return mapping;
  }, [inputData]);

  return {
    handleInputDataChange,
    inputDataMapping,
  };
};

export default useFunctionSelection;
